import { create } from "zustand";
import { combine } from "zustand/middleware";

import { CompanyPensionProduct } from "../types/CompanyPensionProduct";
import { SavingsProfile } from "../types/SavingsProfile";
import { TableType } from "../data/TableType";

type ApplicationState = {
  selectableCompanies: Record<string, Set<string>>;
  companyPensionProducts: CompanyPensionProduct[];
  savingsProfiles: SavingsProfile[];
};

const initialState: ApplicationState = {
  selectableCompanies: {},
  companyPensionProducts: [],
  savingsProfiles: [],
};

const useDataStore = create(
  combine(initialState, (set, get) => ({
    setSelectableCompanies: (companies: Set<string>, tableType: string) =>
      set((state) => ({
        selectableCompanies: {
          ...state.selectableCompanies,
          [tableType]: companies,
        },
      })),
    setCompanyPensionProducts: (
      companyPensionProducts: CompanyPensionProduct[],
    ) => set(() => ({ companyPensionProducts: companyPensionProducts })),
    setSavingsProfiles: (savingsProfiles: SavingsProfile[]) =>
      set(() => ({ savingsProfiles: savingsProfiles })),
    getSelectableCompanies: (tableType: TableType) => {
      const values = get().selectableCompanies[tableType] ?? [];
      return Array.from(values);
    },
  })),
);

export default useDataStore;
